const PASSWORD_POLICY = [
  {
    key: 'minLength',
    label: 'Minimo de 8 caracteres',
    test: (password) => String(password || '').length >= 8,
  },
  {
    key: 'uppercase',
    label: 'Ao menos 1 letra maiuscula',
    test: (password) => /[A-Z]/.test(String(password || '')),
  },
  {
    key: 'lowercase',
    label: 'Ao menos 1 letra minuscula',
    test: (password) => /[a-z]/.test(String(password || '')),
  },
  {
    key: 'number',
    label: 'Ao menos 1 numero',
    test: (password) => /\d/.test(String(password || '')),
  },
  {
    key: 'special',
    label: 'Ao menos 1 caractere especial (!@#$%*-_)',
    test: (password) => /[!@#$%*\-_]/.test(String(password || '')),
  },
];

const evaluatePasswordPolicy = (password) => {
  const checks = PASSWORD_POLICY.map((item) => ({
    key: item.key,
    label: item.label,
    valid: item.test(password),
  }));

  return {
    checks,
    isValid: checks.every((item) => item.valid),
  };
};

export { PASSWORD_POLICY, evaluatePasswordPolicy };
